import { Controller } from "@hotwired/stimulus"

export default class Dialog extends Controller {
  static targets = ["dialog"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    if (this.openValue) {
      this.open()
    }

    this.boundHandleClose = this.#handleClose.bind(this)

    this.dialogTarget.addEventListener("close", this.boundHandleClose)
  }

  disconnect() {
    this.dialogTarget.removeEventListener("close", this.boundHandleClose)
    document.body.style.overflow = ""
  }

  open() {
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"

    if (document.activeElement) {
      document.activeElement.blur()
    }
  }

  close() {
    this.#animateClose(() => this.dialogTarget.close())
  }

  backdropClose() {
    this.close()
  }

  #animateClose(callback) {
    this.dialogTarget.setAttribute("closing", "")
    Promise.all(this.dialogTarget.getAnimations().map(a => a.finished))
      .then(() => {
        this.dialogTarget.removeAttribute("closing")
        callback()
      })
  }

  #handleClose() {
    document.body.style.overflow = ""
  }
}
